import { Toast } from "react-vant";
import { lotteryHandleApi } from "@/api/url.js";
// import { useTranslation } from "react-i18next";;
import { t } from "i18next"

export const waitForTransaction = async (
  id: string,
  boc: string,
  avatarId: string,
  url?: string
) => {
  const toast = Toast.loading({
    message: t("components.transform.the_transaction_is_being_confirmed"),
    duration: 0,
    forbidClick: true,
    className: "custom-toast",
  });
  const r = await lotteryHandleApi(
    { order_id: id, transaction_id: boc, character_id: avatarId },
    url
  );
  toast.clear();
  return r;
};
export const miningWaitForTransaction = async (
  id: string,
  boc: string,
  url?: string,
  config_id?: string
) => {
  const toast = Toast.loading({
    message: t("components.transform.the_transaction_is_being_confirmed"),
    duration: 0,
    forbidClick: true,
    className: "custom-toast",
  });
  const r = await lotteryHandleApi(
    { order_id: id, transaction_id: boc, config_id },
    url
  );
  toast.clear();
  return r;
};
